import { isEmpty } from "lodash";

export function authReducer(
	state = {
		isAuthenticated: false,
		isSuperAdmin: false,
		user: {},
		userInfo: {},
		stats:{},
		currency: "",
		// isEmployee: false,
		// employee: {},
		token: "",
		pageRaw: [],
	},
	{ type, payload }
) {
	switch (type) {
		case "SET_CURRENT_USER":
			let state0 = Object.assign({}, state)
			console.log("SET_CURRENT_USER, payload",payload," - ",payload.role)
			// state0.isAuthenticated = !isEmpty(payload) && payload.role > -1
			// state0.isAdmin = !isEmpty(payload) && payload.role > 1
			state0.isSuperAdmin = !isEmpty(payload) && payload.role == 2 
			state0.user = payload
		
			return state0
			
		case "GET_USER_INFO":
			let state1 = Object.assign({}, state)
			state1.userInfo = payload

			return state1;
			
		case "UPDATE_USER_ACCOUNT":
			let state3 = Object.assign({}, state)
			state3.userInfo.account = payload
			
			return state3;

		case "UPDATE_CURRENT_USER_INFO":
			let state4 = { ...state }
			console.log("DEBUG], UPDATE_CURRENT_USER_INFO", state4, " >>", payload)
			//If superAdmin 
			if (Array.isArray(payload)){
				console.log("DEBUG], UPDATE_CURRENT_USER_INFO, Is super admin", payload)
				state4 = {
					...state4,
					user: {
					  ...state4.user,
					  tokenAcess: payload,
					},
				  };
				localStorage.setItem('accessList_8000', JSON.stringify(payload));
			//If Admin
			}else{
				state4 = {
					...state4,
					user: {
					  ...state4.user,
					  tokenAcess: payload.tokenAcess,
					  accountid: payload.accountid,
					},
				  };
				// state4.user.tokenAcess = payload.tokenAcess
				// state4.user.accountid = payload.accountid	
				localStorage.setItem('userInfo_8000', JSON.stringify(state4));
				localStorage.setItem('accessList_8000', JSON.stringify(payload.tokenAcess));
			}
			
			return state4;

		case "UPDATE_CURRENT_USER_CURRENCY":
			return {
                ...state,
                currency: 'Euro'
            };
		
		default:
			let state5 = Object.assign({}, state)
			state5 = JSON.parse(localStorage.getItem('userInfo_8000')) || {};
			state5.pageRaw = JSON.parse(localStorage.getItem('accessList_8000')) || [];
			
			// return {
			// 	isAuthenticated: false,
			// 	user: {},
			// 	userInfo: {},
			// 	stats:{},
			// 	isEmployee: false,
			// 	employee: {},
			// 	token: "",
			// 	pageList: storedAccessList,
			// }
			return state5;
	}
}
